import {
    GET_SYSTEM_CONFIG,
    GET_SYSTEM_CONFIG_SUCCESS,
    GET_SYSTEM_CONFIG_FAIL,
} from '../../../constants/maintenance/alarmConfigurationConstants/systemConfigurationConstants';

/**
 * Reducer function for managing system alarm configuration state.
 *
 * This reducer handles actions related to fetching system alarm configuration.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the system alarm configuration.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const systemConfigReducer = (state = { system: {} }, action) => {
    switch (action.type) {
        case GET_SYSTEM_CONFIG:
            return {
                loading: true,
            };
        case GET_SYSTEM_CONFIG_SUCCESS:
            return {
                loading: false,
                system: action.payload,
            };
        case GET_SYSTEM_CONFIG_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
